"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropzonePreviewActions = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconWrapper_1 = __importDefault(require("../../Icons/IconWrapper"));
const IconSizes_1 = require("../../Icons/PropTypes/IconSizes");
const ProgressBar_1 = require("../../ProgressBar");
const DropzonePreviewAction_1 = require("./DropzonePreviewAction");
const DropzonePreviewActions = (props) => {
    const { file, actions, readOnly, isLoading, className = "", loadingProgress, onRemovePreview, shouldRenderDeleteAction, } = props;
    const renderPreviewActions = () => {
        return actions === null || actions === void 0 ? void 0 : actions.map(({ ariaLabel, onClick, className, icon, shouldRenderAction, hiddenOnReadOnly = false }, index) => {
            // If Dropzone is in readOnly mode and action should be hidden
            if (readOnly && hiddenOnReadOnly)
                return null;
            // If some condition is not met in the client application
            if (shouldRenderAction && !shouldRenderAction(file))
                return null;
            return (react_1.default.createElement(DropzonePreviewAction_1.DropzonePreviewAction, { key: file.name + index, ariaLabel: ariaLabel, onClick: () => onClick(file), className: className, icon: icon }));
        });
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("dropzone-preview-actions", className) },
        isLoading && (react_1.default.createElement("div", { className: "dropzone-preview-progress" },
            react_1.default.createElement(ProgressBar_1.ProgressBar, { title: file.name, progress: loadingProgress, withPercentage: true }))),
        !isLoading && (actions === null || actions === void 0 ? void 0 : actions.length) && renderPreviewActions(),
        shouldRenderDeleteAction && (react_1.default.createElement(DropzonePreviewAction_1.DropzonePreviewAction, { ariaLabel: `remove ${file.name}`, onClick: () => onRemovePreview(file), className: "dropzone-preview-remove", icon: react_1.default.createElement(IconWrapper_1.default, { name: "Trash2", size: IconSizes_1.IconSizes.Medium }) }))));
};
exports.DropzonePreviewActions = DropzonePreviewActions;
//# sourceMappingURL=DropzonePreviewActions.js.map